// extracted by css-extract-rspack-plugin
export default {"cls1":"PremiumLock-cls1_-dY","cls2":"PremiumLock-cls2_If4 PremiumLock-cls1_-dY"};